import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const CONSULTANT_AUDIT: AppRouteRecordRaw = {
  path: '/audit',
  name: 'consultant-audit',
  component: DEFAULT_LAYOUT,
  redirect: '/audit/list',
  meta: {
    locale: 'menu.ConsultantAudit',
    requiresAuth: true,
    icon: 'icon-dashboard',
    order: 6,
    hideChildrenInMenu: true,
    activeMenu: 'consultant-audit',
  },
  children: [
    {
      path: 'list',
      name: 'consultantAudit',
      component: () => import('@/views/audit/audit.vue'),
      meta: {
        locale: 'menu.ConsultantAudit',
        requiresAuth: true,
        roles: ['AreaAdmin', 'TeamLeader'],
      },
    },
  ],
};
export default CONSULTANT_AUDIT;
